import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import CancelIcon from '@crm/shared/assets/icons/cancel-01.svg?react';
import { cn } from '@crm/shared/lib';

import { Button } from '../Button';
import { SvgIcon } from '../SvgIcon';

interface SelectionActionsBarProps {
    children: ReactNode;
    className?: string;
    label: ReactNode;
    onClose: () => void;
}

export const SelectionActionsBar = ({
    children,
    className,
    label,
    onClose,
}: SelectionActionsBarProps) => {
    const { t } = useTranslation();

    return (
        <div
            className={cn(
                'absolute bottom-0 left-1/2 flex -translate-x-1/2 transform items-center gap-3 rounded-xl bg-smtr-main-black-100 p-3',
                className
            )}
        >
            <div className="flex items-center gap-3">
                <span className="text-xs text-nowrap text-gray-100">{label}</span>
                {children}
            </div>
            <Button
                type="button"
                variant="link"
                className="px-0 text-gray-400"
                aria-label={t('button.cancelSelect.text')}
                onClick={onClose}
            >
                <SvgIcon icon={CancelIcon} size="16" />
            </Button>
        </div>
    );
};
